/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-undef */
import '../styles/App.css';
import '../styles/carousel.css';
import logo from '../assets/header2.png';
import Ticker from './ticker';
import $ from "jquery";
import About from '../components/about';
import up from '../assets/arrow-up.png';
import Footer from '../components/footer';
import navbar from '../assets/navigation-bar.png';
import wrong from '../assets/wrong.png';
import twitter from '../assets/x.png';
import tg from '../assets/tg.png';
import discord from '../assets/discord.png';
import arrow from '../assets/arrow.png';
import notes from '../assets/notes.png';
import download from '../assets/download.png';
import React, { useEffect, useState } from 'react';
import Roadmap from '../components/roadmap';
import Team from '../components/team';
import Carousel from '../components/carousel';
import Rounds from '../components/rounds';
import SNS from '../components/sns';
import Mint from '../components/mint';

var Scroll = require('react-scroll');

var Link = Scroll.Link;
var DirectLink = Scroll.DirectLink;
var Element = Scroll.Element;
var Events = Scroll.Events;
var scroll = Scroll.animateScroll;
var scrollSpy = Scroll.scrollSpy;


$(window).on('load', function () {
	setTimeout(function () { // allowing 3 secs to fade out loader
		$('.page-loader').fadeOut('slow');
	}, 2500);
});

const xLink = () => {
	window.open("#");;
}

const telegLink = () => {
	window.open("#");;
}

const discordLink = () => {
	window.open("https://discord.gg/QA3e36Yh");;
}

const Home = () => {

	const [_navbarOpen, set_navbarOpen] = useState(0);
	const [showButton, setShowButton] = useState(false);

	async function closeNav() {
		set_navbarOpen(0);
	}

	async function navbarOpen() {
		set_navbarOpen(1);
	}

	useEffect(() => {
		function handleScroll() {
			if (window.scrollY > window.innerHeight) {
				setShowButton(true);
			} else {
				setShowButton(false);
			}
		}

		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	document.addEventListener("DOMContentLoaded", () => {
		const images = document.querySelectorAll(".animated-image");
		let index = 0;
		const animationDuration = 3000; // 3 seconds

		function showNextImage() {
			images.forEach(img => img.style.opacity = "0"); // Hide all images
			images[index].style.animation = "moveFlipFade 3s ease-in-out forwards"; // Animate current image

			setTimeout(() => {
				index = (index + 1) % images.length; // Move to next image
				showNextImage();
			}, animationDuration);
		}

		showNextImage(); // Start animation loop
	});

	return (

		<div class="allWrap">

			<div class="light">

				<Element name="up">
					<div class="headers">

						<div class="headers2">

							<div class="logo"><img class="logoPic" src={logo} /></div>

							<div class="right">

								<div class="connect">
									<div ><Link activeClass="" id="fontSize" to="sns" spy={true} smooth={true} duration={550}>SNS</Link></div>
									<div ><Link activeClass="" id="fontSize" to="about" spy={true} smooth={true} duration={550}>REVENUE PLAN</Link></div>
									<div ><Link activeClass="" id="fontSize" to="rouns" spy={true} smooth={true} duration={550}>NFT ROUND</Link></div>
									<div ><Link activeClass="" id="fontSize" to="rm" spy={true} smooth={true} duration={550}>LOADMAP</Link></div>

									<div class="connect2">
										<Link activeClass="" id="fontSize" to="mint" spy={true} smooth={true} duration={550}><button class="wallet2">MINT <img src={arrow} /></button></Link>
									</div>

								</div>

							</div>

						</div>

					</div>
				</Element>

				{_navbarOpen < 1 ?
					(<div class="miniBarMain">
						<div class="logo"><img class="logoPic" src={logo} /></div>

						<div class="navbarMain"><img class="navbar" onClick={navbarOpen} src={navbar} /></div>
					</div>) :
					(<div class="miniBarMain">
						<div class="logo"><img class="logoPic" src={logo} /></div>

						<div class="navbarMain"><img class="navbar" onClick={closeNav} src={wrong} /></div>
					</div>)}

				{_navbarOpen > 0 ?
					(<div class="littleNav">
						<div ><Link activeClass="" id="fontSize" to="sns" spy={true} smooth={true} duration={550}>SNS</Link></div>
						<div ><Link activeClass="" id="fontSize" to="about" spy={true} smooth={true} duration={550}>REVENUE PLAN</Link></div>
						<div ><Link activeClass="" id="fontSize" to="rouns" spy={true} smooth={true} duration={550}>NFT ROUND</Link></div>
						<div ><Link activeClass="" id="fontSize" to="rm" spy={true} smooth={true} duration={550}>LOADMAP</Link></div>

						<div class="connect2">
							<Link activeClass="" id="fontSize" to="mint" spy={true} smooth={true} duration={550}><button class="wallet2">MINT <img src={arrow} /></button></Link>
						</div>

					</div>) : null}

				<div class="cont">

					<div class="introduction">
						<Carousel />
						<div className='title'>
							<img src={logo} /> MUSIC
							<div id="title2">NFT_BUNDA ANGELS</div>
							<div id="title3">MUSIC SAVE</div>
						</div>

						<div className='upLine'>
							<Link activeClass="" id="fontSize" to="mint" spy={true} smooth={true} duration={550}><div className='mintMain'><button>MINT NOW</button></div></Link>

							<div className='upSocial'>
								<img onClick={xLink} src={twitter} />
								<img onClick={telegLink} src={tg} />
								<img onClick={discordLink} src={discord} />
								<a href="/whitepaper(EN).pdf" download>
									<img src={download} alt="Download White Paper" />
								</a>

							</div>


						</div>
					</div>

					<div className='imgContainer'><img className='mainNotes' src={notes} /></div>

				</div>

				<Ticker />

				<Element name="sns">
					<SNS />
				</Element>

				<Element name="about">
					<About />
				</Element>

				<Element name="mint">
					<Mint />
				</Element>

				<Element name="rouns">
					<Rounds />
				</Element>

				<Element name="rm">
					<Roadmap />
				</Element>

				<Team />

			</div >

			<Footer />
			{showButton ?
				<Link to="up" id="sticky-button" spy={true} smooth={true} duration={550}><img class="stickyBtn2" src={up} /></Link>
				: null}

		</div >
	)
}

export default Home;
